<div class="error-container d-flex align-items-center justify-content-center text-center" *ngIf="!isLoading">
  <div class="container">
    <img src="assets/images/no-reservation.png" alt="no-reservation-image">
    <h2 class="mb-2">Reservations currently unavailable</h2>
    <p class="mb-5 pb-5">Please enable reservations setting in the branch configuration</p>
  </div>
</div>
